import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.calculateMatchingResponsesTimeout = null;
    $('.select2').select2()
    $('.select2').on('select2:select select2:unselect', function () {
      let event = new Event('change', { bubbles: true }) // fire a native event
      this.dispatchEvent(event);
    });
  }

  debouncedCalculateMatchingResponses(event) {
    clearTimeout(this.calculateMatchingResponsesTimeout);
    const surveyId = event.currentTarget.dataset.surveyId;
    
    this.calculateMatchingResponsesTimeout = setTimeout(() => {
      this.calculateMatchingResponses(surveyId);
    }, 300);
  }

  calculateMatchingResponsesSelect(event) {
    this.calculateMatchingResponses(event.currentTarget.dataset.surveyId);
  }

  calculateMatchingResponses(surveyId) {
    const form = document.getElementsByClassName('survey_report_delivery_form')[0];
    let serializedData = $(form).serialize();
    serializedData = serializedData.replace(/patch/, 'post');

    $.ajax({
      url: `/surveys/${surveyId}/survey_report_deliveries/respondents_count`,
      method: 'POST',
      data: serializedData,
      success: function(data) {
        document.getElementById('matching-responses-count').textContent = `Matching Respondents: ${data.count}`;
      }
    });

  }

  removeFilterAndRecalculate(event) {
    event.preventDefault();
    const target = event.currentTarget;
    target.closest(`.${target.dataset.targetClass}`).remove();
    this.calculateMatchingResponses(target.dataset.surveyId);
  }
}